export default "__VITE_ASSET__IYDqG0Gr__"